import React, { FC } from 'react';
import { Container, Box, Flex, Text, Hide } from 'roo-ui/components';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { oneworld } from 'roo-ui/logos';
import { Links } from './Links';
import { LinkOptions } from '../../lib/types';

const Logo = styled.img`
  width: ${rem('40px')};
  margin-right: ${themeGet('space.2')};
`;

const StyledText = styled(Text)`
  color: ${themeGet('colors.greys.steel')};
  font-size: ${themeGet('fontSizes.xs')};
`;

const PrintOnlySection: FC = ({ children }) => (
  <Hide xs sm md lg>
    {children}
  </Hide>
);

export interface FooterProps {
  links: LinkOptions[];
}

export const Footer: FC<FooterProps> = ({ links }) => (
  <>
    <Box
      pt={[2, 3, 3]}
      pb={[4, 7, 7]}
      borderTop={2}
      borderColor="brand.primary"
      data-print-style="hidden"
    >
      <Container pb={9}>
        <Flex
          mt={2}
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
        >
          <Hide sm xs>
            <Links links={links} />
          </Hide>
          <Flex
            mb={2}
            alignItems="center"
            justifyContent={['flex-start', 'flex-start', 'flex-end']}
          >
            <Logo
              src={oneworld}
              alt="One World Logo"
              role="img"
              aria-label="One World Logo"
              data-testid="one-world-logo"
            />
            <StyledText data-testid="abn">
              &copy; Qantas Airways Limited ABN 16 009 661 901
            </StyledText>
          </Flex>
        </Flex>
      </Container>
    </Box>

    <PrintOnlySection>
      <Box pt={3} pb={7} borderTop={1} borderColor="greys.alto">
        <Flex alignItems="center">
          <Flex alignItems="center">
            <Logo
              src={oneworld}
              alt="One World Logo"
              role="img"
              aria-label="One World Logo"
              data-testid="one-world-logo-print"
            />
            <StyledText ml={4} data-testid="abn-print">
              &copy; Qantas Airways Limited ABN 16 009 661 901
            </StyledText>
          </Flex>
        </Flex>
      </Box>
    </PrintOnlySection>
  </>
);
